var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('x-default-data-table',{attrs:{"x-options":_vm.tableOptions},scopedSlots:_vm._u([{key:"item.dateTime",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(item.date + '/' + item.month + '/' + item.year)+" ")])]}},{key:"item.point",fn:function(ref){
var item = ref.item;
return [(item.point)?_c('span',[_vm._v(" "+_vm._s(_vm._f("currency")(item.point))+" VND")]):_c('span',[_vm._v("0 VND")])]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [(item.status === 0)?_c('span',[_vm._v("Unpaid")]):(item.status === 1)?_c('span',[_vm._v("Paid")]):_c('span',[_vm._v("Unknown")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }